module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-restaurant-f50c78b2f403deb2d162055a286f2dfe.png";